var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"white--text",attrs:{"color":"green","small":"","loading":_vm.bindAdminLoading},on:{"click":_vm.click}},[_vm._v("綁定會員")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }